import DashboardLayout from "@/layout/DashboardLayout.tsx";
import BillingComponent from "@/components/pages/BillingComponent.tsx";

export default function BillingView() {
    return (
        <DashboardLayout>
            <BillingComponent/>
        </DashboardLayout>
    );
}
